<div mat-dialog-title>
    <h2>Filtro de pesquisa</h2>

    <ng-container *ngIf="submiting">
        <mat-progress-spinner mode="indeterminate" [diameter]="20"></mat-progress-spinner>
    </ng-container>
    <span class="mat-body-2 count" *ngIf="totalCandidates">{{ totalCandidates }} resultados encontrados</span>
    <span class="mat-body-2 count" *ngIf="!totalCandidates">Sem resultados</span>

</div>

<mat-dialog-content>

    <p class="mat-body-1" style="margin-bottom: 20px;">
        Preencha pelo menos um campo abaixo para filtrar a lista de candidatos.
    </p>

    <form [formGroup]="form">
        <fieldset>
            <legend>Profissional</legend>

            <ng-container *ngIf="form.get('jobDescription').value.length > 1">
                <div class="row">
                    <mat-slide-toggle color="primary" formControlName="embracing">
                        Deixar mais abrangente
                    </mat-slide-toggle>
                </div>
                <br />
            </ng-container>

            <div class="row">
                <mat-form-field appearance="outline">
                    <mat-label>Descrição da experiência</mat-label>
                    <mat-chip-list #wordChipList [disabled]="submiting">
                        <mat-chip *ngFor="let word of form.get('jobDescription').value; let i = index" [select]="true"
                            [selectable]="true" (removed)="removeWord(i)">
                            {{ word }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input placeholder="Digite a palavra chave aqui" [matChipInputFor]="wordChipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addJobDescription($event)">
                    </mat-chip-list>
                    <mat-hint>Use apenas palavras</mat-hint>
                </mat-form-field>
            </div>

        </fieldset>
        <br />
        <fieldset>
            <legend>Perfil</legend>

            <div class="row">
                <mat-form-field appearance="fill">
                    <mat-label>Idade inicial</mat-label>
                    <mat-select formControlName="ageStart">
                        <mat-option value=""></mat-option>
                        <ng-container *ngFor="let age of ages">
                            <mat-option [value]="age">{{age}}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>

                <ng-container *ngIf="form.get('ageStart').value != '65+'">
                    <mat-form-field appearance="fill">
                        <mat-label>Idade final</mat-label>
                        <mat-select formControlName="ageEnd">
                            <mat-option value=""></mat-option>
                            <ng-container *ngFor="let age of ages">
                                <mat-option [value]="age">{{age}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
            </div>

            <div class="row">
                <mat-form-field appearance="fill" style="flex: 1">
                    <mat-label>Sexo</mat-label>
                    <mat-select matInput placeholder="Escolha o sexo" formControlName="gender"
                        (selectionChange)="onGenderSelected()">
                        <mat-option value="all">Todos</mat-option>
                        <mat-option value="masculino">Masculino</mat-option>
                        <mat-option value="feminino">Feminino</mat-option>
                        <mat-optgroup label="Outros gêneros">
                            <ng-container *ngFor="let gender of genders$ | async">
                                <mat-option [value]="gender.gender">{{ gender.gender }}</mat-option>
                            </ng-container>
                        </mat-optgroup>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="row">

                <mat-form-field appearance="fill">
                    <mat-label>Estado</mat-label>
                    <mat-autocomplete #autoState="matAutocomplete" [displayWith]="displayState"
                        (optionSelected)="onStateSelected($event)">
                        <mat-option style="display: none"></mat-option>
                        <ng-container *ngFor="let state of filteredStates$ | async">
                            <mat-option [value]="state">{{ state.nome }}</mat-option>
                        </ng-container>
                    </mat-autocomplete>
                    <input matInput type="text" id="state" placeholder="Informe o estado" formControlName="state"
                        #inputState="matAutocompleteTrigger" (input)="onStateChange($event)"
                        (focus)="onFocusInput('state')" [matAutocomplete]="autoState" />
                </mat-form-field>

                <mat-form-field appearance="fill" *ngIf="showCity">
                    <mat-label>Cidade</mat-label>
                    <mat-autocomplete #autoCity="matAutocomplete" (optionSelected)="onCitySelected($event)">
                        <ng-container *ngFor="let city of filteredCities$ | async">
                            <mat-option [value]="city.name">{{ city.name }}</mat-option>
                        </ng-container>
                    </mat-autocomplete>
                    <input matInput type="text" id="city" placeholder="Informe a cidade" formControlName="city"
                        (input)="onCityChange($event)" (focus)="onFocusInput('city')" [matAutocomplete]="autoCity" />
                    <mat-hint>Escolha o estado para mostrar as cidades</mat-hint>
                </mat-form-field>

            </div>
        </fieldset>

        <fieldset>
            <legend>Escolaridade</legend>

            <div class="row">

                <mat-form-field appearance="fill">
                    <mat-label>Nivel de escolaridade</mat-label>
                    <mat-select placeholder="Escolha o nivel de escolaridade" formControlName="educationLevel"
                        (selectionChange)="onEducationLevelSelected()">
                        <mat-option value="">Todos</mat-option>
                        <mat-option value="ens-sup-nivel4">Ensino Superior (Doutorado)</mat-option>
                        <mat-option value="ens-sup-nivel3">Ensino Superior (Mestrado)</mat-option>
                        <mat-option value="ens-sup-nivel2">Ensino Superior (Pós graduação)</mat-option>
                        <mat-option value="ens-sup-nivel">Ensino Superior (Graduação)</mat-option>
                        <mat-option value="ens-med-nivel">Ensino Médio</mat-option>
                        <mat-option value="ens-fun-nivel">Ensino Fundamental</mat-option>
                        <mat-option value="curso-tecnico">Outros Técnico</mat-option>
                        <mat-option value="mba">MBA</mat-option>
                        <mat-option value="curso-extra">Outros Cursos</mat-option>
                    </mat-select>
                </mat-form-field>

            </div>

        </fieldset>
    </form>

</mat-dialog-content>
<mat-dialog-actions>
    <button color="warn" mat-button mat-dialog-close>Cancelar</button>
    <button color="primary" mat-stroked-button (click)="clearFilter()" [disabled]="submiting">Limpar filtro</button>
    <button color="primary" mat-raised-button (click)="submit()" [disabled]="totalCandidates == 0">Pesquisar</button>
</mat-dialog-actions>